"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getRpcProviderUrl = (networkName = 'mainnet') => {
    let rpcUrl;
    // override url if environment variable is set
    if (process.env.AUTHEREUM_UTILS_RPC_PROVIDER_URL) {
        return process.env.AUTHEREUM_UTILS_RPC_PROVIDER_URL;
    }
    if (/^https?:\/\//.test(networkName)) {
        rpcUrl = networkName;
    }
    else {
        rpcUrl = `https://${networkName}.rpc.authereum.com`;
        if (networkName === 'ganache') {
            rpcUrl = 'http://localhost:8545';
        }
    }
    return rpcUrl;
};
exports.default = getRpcProviderUrl;
